import React from "react";
import "./Data_Curriculum.css";
import { Nav, Tab } from "react-bootstrap";
import Beginner_Curriculum from "./beginner-curriculum/Beginner_Curriculum";
import Advance_Curriculum from "./advance-curriculum/Advance_Curriculum";

const Data_Curriculum = ({ program }) => {
  const programData = Array.isArray(program) ? program[0] : program;
  const curriculumModules = programData?.curriculum_model || [];

  // Separate beginner and advanced modules by type
  const beginnerModules = curriculumModules.filter((mod) => mod.type === "beginner");
  const advancedModules = curriculumModules.filter((mod) => mod.type === "advanced");

  return (
    <section className="Data_Curriculum">
      <div className="container">
        <div className="Data_Curriculum_header">
          <h5>
             {program.name} <span>Curriculum</span>{" "}
          </h5>
        </div>

        <div className="Data_Curriculum_content_div">
          <Tab.Container defaultActiveKey="beginner">
            <Nav variant="pills" className="custom_nav_pills p-2">
              <Nav.Item className="text-center">
                <Nav.Link eventKey="beginner">Beginner Curriculum</Nav.Link>
              </Nav.Item>

              <Nav.Item className="text-center">
                <Nav.Link eventKey="advanced">Advanced Curriculum</Nav.Link>
              </Nav.Item>
            </Nav>

            {/* TAB CONTENT */}
            <Tab.Content>
              <Tab.Pane eventKey="beginner">
                <Beginner_Curriculum modules={beginnerModules} />
              </Tab.Pane>
              <Tab.Pane eventKey="advanced">
                <Advance_Curriculum modules={advancedModules} />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </section>
  );
};

export default Data_Curriculum;